import { Button, Form, Input, message, Select, Space } from "antd";
import {useNavigate} from 'react-router-dom'
import React, { useState } from "react";
import styles from './NewRequest.module.css'
import api from "../../api/api";
import * as actions from "../../store/actions/action";
import { connect } from "react-redux";
import { PageHeader } from "@ant-design/pro-components";
const { Option } = Select;

const NewRequest = ({ErrorSetter, ClearError, LoadingSetter, ClearLoading , token , loading}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = (values) => {
    LoadingSetter()
    console.log("Received values of form: ", values);
    api.post('/students' , values ,{headers : {Authorization : 'Token ' + token}}).then(()=>{
      ClearLoading();
      ClearError();
      form.resetFields();
      message.success('درخواست جدید با موفقیت ثبت شد.')
    })
    .catch(()=>{
      ClearLoading();
      ErrorSetter('ثبت درخواست موفق نبود!')
    })

  };

  return (
    <div>
      <PageHeader
        className="site-page-header"
        title="ثبت درخواست جدید"
        extra={<Space></Space>}
        // avatar={{ icon: <PlusOutlined /> }}
        onBack={()=>{navigate('/Requests')}}
      />
      <div className={styles.FormContainer}>
      <Form
        layout="vertical"
        form={form}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
        className={styles.Form}
      >
        <Form.Item
          name="first_name"
          label="نام"
          rules={[
            {
              required: true,
              message: "لطفا نام را وارد کنید!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="last_name"
          label=" نام خانوادگی"
          rules={[
            {
              required: true,
              message: "لطفا نام خانوادگی را وارد کنید!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone_number"
          label="شماره تلفن"
          rules={[
            {
              required: true,
              message: "لطفا شماره تلفن را وارد کنید!",
            },
          ]}
        >
          <Input
            style={{
              width: "100%",
            }}
          />
        </Form.Item>

        <Form.Item
          name="city_live"
          label="شهر محل سکونت"
          rules={[
            {
              required: true,
              message: "لطفا شهر محل سکونت را وارد کنید!",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="aim_to_learn"
          label="دلیل یادگیری زبان"
          rules={[
            {
              required: true,
              message: "لطفا دلیل یادگیری زبان را وارد کنید!",
            },
          ]}
        >
          <Select placeholder="دلیل یادگیری زبان را انتخاب کنید:">
            <Option value="مهاجرت">مهاجرت</Option>
            <Option value="ترجمه مقالات">ترجمه مقالات</Option>
            <Option value="نیاز شغلی">نیاز شغلی</Option>
            <Option value="مهارت افزایی">مهارت افزایی</Option>
            <Option value="سایر">سایر</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="job"
          label="شغل"
          rules={[
            {
              required: true,
              message: "لطفا شغل را وارد کنید!",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button loading={loading} block type="primary" htmlType="submit">
             ثبت درخواست جدید
          </Button>
        </Form.Item>
      </Form>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    token : state.token,
    loading : state.loading
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ErrorSetter: (error, errorType) =>
      dispatch(actions.ErrorSetter(error, errorType)),
    ClearError: () => dispatch(actions.ClearError()),
    LoadingSetter: (error, errorType) => dispatch(actions.LoadingSetter()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
  };
};
export default connect(mapStateToProps , mapDispatchToProps)(NewRequest);
